import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Question } from '../../../../../classes';
import { Subscription } from 'rxjs';
@Component({
  selector: 'question-tags',
  templateUrl: './question-tags.component.html',
  styleUrls: ['./question-tags.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTagsComponent {
  @Input() question: Question;
  get hasQuotaOptions(): boolean {
    return this.question.options.find(
      o => typeof o.quota === 'number' && o.quota > 0
    )
      ? true
      : false;
  }
  subscriptions: Subscription[] = [];
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    this.subscriptions.push(
      this.question.onContentUpdate.subscribe(() => {
        this.cdRef.detectChanges();
      })
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
